import { Box, Typography, Button, Chip, useTheme } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import BusinessIcon from '@mui/icons-material/Business';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

interface LockerHeaderProps {
  data: {
    id: string;
    name: string;
    is_available: boolean;
    tenantName?: string;
    port?: string;
    mac?: string;
  };
  onEdit: (id: string) => void;
  onDelete: (data: any) => void;
}

export function LockerHeader({ data, onEdit, onDelete }: LockerHeaderProps) {
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, mb: 3 }}>
      <Box sx={{
        width: 80,
        height: 80,
        borderRadius: 2,
        backgroundColor: data.is_available ? theme.palette.success.main : theme.palette.error.main,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <LockIcon sx={{ fontSize: 40, color: 'white' }} />
      </Box>
      
      <Box sx={{ flex: 1 }}>
        <Typography variant="h4" fontWeight={800} color={theme.palette.text.primary} mb={1}>
          {data.name}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
          <Chip
            icon={data.is_available ? <CheckCircleIcon /> : <CancelIcon />}
            label={data.is_available ? 'Disponível' : 'Indisponível'}
            color={data.is_available ? 'success' : 'error'}
            size="small"
            variant="outlined"
          />
          {data.tenantName && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <BusinessIcon sx={{ fontSize: 16, color: theme.palette.text.secondary }} />
              <Typography color={theme.palette.text.secondary} fontSize={14}>
                {data.tenantName}
              </Typography>
            </Box>
          )}
        </Box>
        <Typography color={theme.palette.text.secondary} fontSize={14}>
          Porta: {data.port} • MAC: {data.mac}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 2, mb: 2 }}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<LockIcon />}
          sx={{ fontWeight: 700, fontSize: 16, borderRadius: 2, px: 4, py: 1.5, textTransform: 'none', boxShadow: 'none', minWidth: 180 }}
          onClick={() => onEdit(data.id)}
        >
          Editar Armário
        </Button>
        <Button
          variant="outlined"
          color="error"
          startIcon={<DeleteOutlineIcon />}
          sx={{ color: '#EF4444', borderColor: '#F3D1D1', fontWeight: 700, fontSize: 16, borderRadius: 2, px: 4, py: 1.5, textTransform: 'none', boxShadow: 'none', bgcolor: '#FFF0F0', minWidth: 180, '&:hover': { bgcolor: '#FFE5E5', borderColor: '#F3D1D1' } }}
          onClick={() => onDelete(data)}
        >
          Excluir Armário
        </Button>
      </Box>
    </Box>
  );
} 